<template>
    <div class="content-box">
        <div class="container mb-20">
            <div class="info-box df fww">
                <div class="left-box">
                    <div class="title df">
                        <div class="t1 f1">{{ info.tp_title }}</div>
                        <span class="s1" v-if="info.ai_original_url" @click="handleLink(info.ai_original_url)">{{
                            $t('原文链接') }}</span>
                    </div>
                    <!-- 作者 -->
                    <div class="author-box df aic">
                        <span class="author">{{ info.is_expert == 10 && false
                            ? info.publisher_info.user_name
                            : info.tp_type == 20 ||
                                info.user_id == 0 ||
                                info.publisher_info == null ||
                                info.publisher_info.user_nick_name === "" ||
                                info.publisher_info.user_nick_name === null
                                ? $t("匿名用户")
                                : info.publisher_info.user_nick_name }}</span>
                        <span class="date">{{ $t('发布于') }} {{ info.tp_published_time_before }}</span>
                        <div class="browse">
                            <span class="iconfont">&#xe611;</span>
                            <span>{{ info.tp_hits }}</span>
                        </div>
                    </div>
                    <!-- 摘要 -->
                    <!-- <div class="abstract-box"><span>摘要:</span>{{ info.tp_desc }}</div> -->
                    <!-- 正文 -->
                    <div class="text-content" v-html="info.tp_content"></div>

                    <!-- 附件 -->
                    <div class="attachment-box df fww">
                        <div v-for="(item, index) in info.tp_annex_arr" :key="item.att_id"
                            class="attachment-list over-h">
                            <img :src="getDoc(item.att_title)" alt="">
                            <div class="title one-text" :title="item.att_title">{{ item.att_title }}</div>
                            <div class="size mt-6">{{ item.att_size }}kb</div>
                            <!-- 下载次数 -->
                            <div class="download">
                                {{ $t('下载次数') }} : {{ item.download_times }}
                            </div>
                            <el-button class="btn" type="primary" plain
                                @click="download({ content_id: info.tp_id, att_id: item.att_id, type: 40 })">{{ $t('下载')
                                }}</el-button>
                        </div>


                    </div>


                    <!-- 点赞收藏分享 -->
                    <div class="share-box df jcc">
                        <div class="list" @click="handleLike(info.tp_id)" v-throttle="1000"
                            :class="{ 'active': info.have_like }">
                            <div class="round df fdc jcc aic">
                                <span class="iconfont"> &#xe61b;</span>
                                <p class="number">{{ info.tp_likes }}</p>
                            </div>
                            <el-button type="text" class="p1 pt-0 pb-0 mt-12 mb-0 c-3 lh-20 fs-14"
                                :loading="likeLoading">{{ $t("点赞")
                                }}</el-button>

                            <!-- <p class="p1">{{ $t('点赞') }}</p> -->
                        </div>

                        <div class="list" @click="handleCollection(info.tp_id)" v-throttle="1000"
                            :class="{ 'active': info.have_collection }">
                            <div class="round df fdc jcc aic">
                                <span class="iconfont">&#xe65e;</span>
                                <p class="number">{{ info.tp_collection_count }}</p>
                            </div>
                            <el-button type="text" class="p1 pt-0 pb-0 mt-12 mb-0 c-3 lh-20 fs-14"
                                :loading="collectionLoading">{{ $t("收藏") }}</el-button>

                            <!-- <p class="p1">{{ $t('收藏') }}</p> -->
                        </div>

                        <div class="bdsharebuttonbox shares-box list">
                            <a href="javascript:void(0)" @click="handleShare(info.tp_id)" v-throttle="1000"
                                class="bds_more" :data-cmd="currentLanguage == 'zh' ? 'more' : ''">
                                <div class="shares">
                                    <div class="round df fdc jcc aic">
                                        <span class="iconfont">&#xe61c;</span>
                                        <p class="number">{{ info.tp_share_count }}</p>
                                    </div>
                                    <el-button type="text" class="p1 pt-0 pb-0 mt-12 mb-0 c-3 lh-20 fs-14"
                                        >{{ $t("分享") }}</el-button>
                                    <!-- <p class="p1">{{ $t('分享') }}</p> -->
                                </div>
                            </a>

                            <!-- 英文版分享 -->
                            <div class="sharewx-link" style="position: absolute;" v-if="currentLanguage != 'zh'">
                                <div class="bdsharebuttonbox df fdc">
                                    <a href="#" class="bds_weixin" data-cmd="weixin" title="WeChat">WeChat</a>
                                    <a href="#" class="bds_linkedin" data-cmd="linkedin" title="linkedin">LinkedIn</a>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
                <div class="right-box">
                    <!-- 作者信息 -->
                    <div class="author-content">
                        <div class="title">{{ $t('作者信息') }}</div>
                        <div class="user-info df aic jcc" :class="{ 'cup': info.tp_type == 10 }"
                            @click="info.tp_type == 10 ? handleUserinfo(info.publisher_info) : ''">
                            <div class="avatar">
                                <el-avatar :size="50"
                                    :src="info.tp_type == 10 ? info.publisher_info?.user_avatar_att_url : require('@/assets/images/avatar.png')"
                                    @error="$erroravatarHandler">
                                    <img src="@/assets/images/avatar.png" alt="" />
                                </el-avatar>
                            </div>
                            <div class="name">
                                {{ info.tp_type == 10 ? info.publisher_info?.user_nick_name : $t("匿名用户") }}
                            </div>
                        </div>
                        <div class="type-list df aic" v-if="info.tp_type == 10">
                            <div class="li f1">
                                <p>{{ $t("帖子") }}</p>
                                <span>{{ info.publisher_info?.user_post_count }}</span>
                            </div>
                            <div class="li f1">
                                <p>{{ $t("粉丝数") }}</p>
                                <span>{{ info.publisher_info?.user_fans_count }}</span>
                            </div>
                            <div class="li f1">
                                <p>{{ $t("关注人数") }}</p>
                                <span>{{ info.publisher_info?.user_follow_count }}</span>
                            </div>
                        </div>

                        <div class="btn-box df jcc" v-if="info.tp_type == 10">
                            <el-button class="btn1 red-btn" :loading="publisherFollowLoading"
                                @click="handlePostSubmitted(info.publisher_info?.user_id)"><span>+</span>{{
                                    info.publisher_info?.have_be_follow ? $t('已关注') : $t('关注') }}</el-button>
                            <!-- <el-button class="btn2 f1">给TA留言</el-button> -->
                        </div>
                    </div>

                    <!-- 相关文章 -->
                    <div class="article-box mt-12">
                        <div class="title df aic jcsb">
                            {{ $t("相关推荐") }}
                            <el-button type="text" @click="changeRelated" class="btn" :loading="refreshLoading"><span
                                    class="iconfont">&#xe619;</span>{{ $t('换一批') }}</el-button>
                        </div>

                        <div class="article-boxs">
                            <div class="list" v-for="(item) in info.relation_post_list" :key="item.tp_id"
                                @click="$navigate('/discuss/info', item.tp_id)">
                                <div class="tit1">
                                    {{ item.tp_title }}
                                </div>
                                <div class="type df">
                                    <div><span class="iconfont">&#xe611;</span>{{ item.tp_hits }}</div>
                                    <div class="ml-16">
                                        <span class="iconfont">&#xe61b;</span>{{ item.tp_likes }}
                                    </div>
                                </div>
                            </div>

                            <div class="no-data pt-86" v-if="info.relation_post_list.length == 0">
                                <img src="@/assets/images/empty_data.png" alt="" />
                                <p>{{ $t("暂无数据") }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>




            <el-dialog :title="$t('回复')" :visible.sync="dialogVisible" width="886px" :before-close="closeDialog">

                <div class="df reply-person mb-12">
                    <span class="fn mr-16 c-9 fs-14">{{ $t('回复') }}</span>
                    <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 10 }" :placeholder="$t('请输入您的回复')"
                        v-model="form.tpa_content"></el-input>
                </div>

                <div class="languige-text harmonyos-text" v-if="userinfo.user_expert == 10 && false">
                    {{ $t('以实名身份发布') }}
                    <el-tooltip :content="$t('以专家身份实名评论后页面会同步展示实名信息')" placement="bottom-start" effect="light">
                        <span class="iconfont">&#xe677;</span>
                    </el-tooltip>
                    <el-checkbox-group v-model="form.is_expert" style="display: inline-block;" class="ml-23">
                        <el-checkbox :key="10" :label="10">{{ $t('是') }}</el-checkbox>
                    </el-checkbox-group>

                </div>



                <span slot="footer" class="dialog-footer">
                    <el-button @click="closeDialog" class="btn1">{{ $t('取消') }}</el-button>
                    <el-button type="primary" class="btn2" @click="handelSubPer">{{ $t('确定') }}</el-button>
                </span>
            </el-dialog>
        </div>


        <div class="discuss-content">
            <div class="discuss-box">
                <div class="container-1752">
                    <discuss :id="tpId" :data="discussData" :userinfo="userinfo" :is_moderator="is_moderator"></discuss>
                </div>
            </div>
        </div>

        <!-- 个人信息 -->
        <avatarTop ref="avatarDialog" :publisherFollowLoading="publisherFollowLoading"
            @post-submitted="handlePostSubmitted" :id="id" />

    </div>
</template>

<script>
import { info, share, toggleLike, replyPostAns, toggleCollection, ansList, related, downAnnex } from '@api/post';
import { getMyInfo, setuserfollowAdd } from "@api/home";
import Cookies from 'js-cookie';

// 问题研讨
import discuss from "./components/discuss.vue";

export default {
    components: {
        discuss,
    },
    data() {
        return {
            id: 0,
            info: {
                relation_post_list: [],
            },
            dialogVisible: false,  //回复弹框
            // 是否是英文版
            currentLanguage: localStorage.getItem("currentLanguage"),

            refreshLoading: false,

            userinfo: [],
            // 问题研讨
            discussData: [],
            is_moderator: 20,//是否是版主
            form: {
                tpa_content: '',
                is_expert: [10],
            },
            likeLoading: false,
            collectionLoading: false,
            cookies: Cookies.get('siteData'),

            shareLoading: false,

            publisherFollowLoading: false
        };
    },
    computed: {
        tpId() {
            return this.$route.params.id
        },
        is_preview() {
            return this.$route.params.is_preview
        }
    },
    created() {
        document.addEventListener('visibilitychange', this.changeTwsId)
    },
    destroyed() {
        document.removeEventListener('visibilitychange', this.changeTwsId)
    },
    mounted() {
        // 设置默认的顶部菜单背景色
        this.$bus.$emit("changeNavbg", "#FAFAFA");
        info({ id: this.tpId, is_preview: this.is_preview }).then(res => this.info = res.data);

        ansList({ id: this.tpId }).then(res => {
            // res.data.post_ans_list递归给这个每一层的children加上is_loading
            // 通过递归加
            // this.discussData=this.addIsLoading(res.data.post_ans_list);
            this.discussData = this.addIsLoading(res.data.post_ans_list);
            this.is_moderator = res.data.is_moderator;
        })

        this.getCurrUserData();
    },
    methods: {
        // 当显示时 设置当前的语言
        changeTwsId(e) {
            if (e.target.visibilityState == 'visible') {
                // 设置cookies
                Cookies.set('siteData', this.cookies);
                localStorage.setItem('currentLanguage', this.currentLanguage);
            }
        },

        addIsLoading(arr) {
            // 返回值是一个新的数组
            return arr.map(item => {
                item.is_loading = false;
                if (item.children && item.children.length > 0) {
                    item.children = this.addIsLoading(item.children);
                }
                return item;
            });
        },
        download(params) {
            if (this.userinfo.length == 0) {
                sessionStorage.clear();
                setTimeout(() => {
                    let str = "/cn";

                    let Language = localStorage.getItem('currentLanguage');  //获取本地语言
                    if (Language && Language != 'zh') {
                        str = '/en';
                    } else {
                    }

                    const parsedUrl = new URL(window.location.href);
                    const path = parsedUrl.pathname; // This will give you the path

                    const url = str + '/login?callback=' + path; // 你想要跳转的 URL
                    window.open(url);
                }, 1000);
                return;
            }

            window.location.href = "/api/protal/api/post/downAnnex?content_id=" + params.content_id + "&att_id=" + params.att_id + "&type=40";
        },
        getDoc(title) {
            const filePath = title;
            const fileType = filePath.split(".").pop(); // 获取扩展名

            let png = ["png", "jpg", "bmp", "tif", "gif", "pcx", "svg", "webp"];
            let doc = ["doc", "docx", "DOC", "ODCX"];
            let ppt = ["ppt", "pptx", "pps", "ppsx", "pot", "potx", "odp", "xml"];
            let pdf = [
                "pdf",
                "pdf/a",
                "pdf/x",
                "pdf/e",
                "pdf/ua",
                "pdf/1.4",
                "pdf/1.5",
                "pdf/2.0",
            ];
            let mp4 = [
                "mp4",
                "mkv",
                "avi",
                "mov",
                "wmv",
                "flv",
                "webm",
                "mpeg",
                "mpg",
                "3gp",
                "mp3",
                "wav",
                "aac",
                "flac",
                "ogg",
                "wma",
                "m4a",
                "aiff",
                "opus",
            ];
            let txt = [
                "txt",
                "csv",
                "log",
                "md",
                "xml",
                "json",
                "html",
                "yaml",
                "ini",
                "tex",
            ];
            let excel = ["xls", "xlsx", "xlsm", "xlsb", "csv", "txt", "xml", "ods"];

            let typePath = "default";
            if (png.includes(fileType)) {
                typePath = "png";
            } else if (doc.includes(fileType)) {
                typePath = "doc";
            } else if (ppt.includes(fileType)) {
                typePath = "ppt";
            } else if (pdf.includes(fileType)) {
                typePath = "pdf";
            } else if (mp4.includes(fileType)) {
                typePath = "mp4";
            } else if (txt.includes(fileType)) {
                typePath = "txt";
            } else if (excel.includes(fileType)) {
                typePath = "excel";
            } else {
                typePath = "default";
            }

            return require("@/assets/images/file/" + typePath + ".png");
        },
        handleLink(url) {
            window.open(url)
        },
        async handelSubPer() {

            if (this.form.tpa_content.replace(/ /g, "") == "") {
                this.$message({
                    message: this.$t('请填写正确的回复内容'),
                    type: 'error',
                    customClass: 'mt-60' // 添加自定义类
                });
                return false;
            }

            if (this.userinfo.user_expert == 20) this.form.is_expert[0] = 20;
            this.form.is_expert = this.form.is_expert.length > 0 ? this.form.is_expert[0] : '';

            // 立即提问
            let res = await replyPostAns({ ...this.form, tp_id: this.tpId });
            if (res.status == 200) {
                this.$message({
                    message: res.msg,
                    type: 'success',
                    customClass: 'mt-60' // 添加自定义类
                });
            }

            this.dialogVisible = false;
            this.form = {
                tpa_content: '',
                is_expert: [10]
            };
            this.getData();

        },
        closeDialog() {
            this.dialogVisible = false;
            setTimeout(() => {
                this.form = {
                    tpa_content: '',
                    is_expert: [10],
                };

            }, 200);
        },
        async getCurrUserData() {
            let res = await getMyInfo();
            if (res.status == 200) {
                this.userinfo = res.data;
            }
        },
        handleUserinfo(item) {
            this.id = item.user_id;
            this.$refs.avatarDialog.openModal();
        },
        // 分享
        handleShare(id) {
            this.shareLoading = true;
            share({ id }).then(() => {
                this.shareLoading = false;
                this.info.tp_share_count++;
            }).finally(() => {
                this.shareLoading = false;
            })
        },
        // 点赞
        handleLike(id) {
            this.likeLoading = true;
            toggleLike({ id }).then((res) => {
                if (res.status == 200) {
                    this.$message.success(res.msg);
                    this.info.tp_likes = this.info.have_like ? this.info.tp_likes - 1 : this.info.tp_likes + 1;
                    this.info.have_like = !this.info.have_like;
                }
            }).finally(() => {
                this.likeLoading = false;
            })
        },
        // 收藏
        handleCollection(id) {
            this.collectionLoading = true;
            toggleCollection({ id }).then((res) => {
                if (res.status == 200) {
                    this.$message.success(res.msg);
                    this.info.tp_collection_count = this.info.have_collection ? this.info.tp_collection_count - 1 : this.info.tp_collection_count + 1;
                    this.info.have_collection = !this.info.have_collection;
                }
            }).finally(() => {
                this.collectionLoading = false;
            })
        },
        // 关注弹框用户
        async handlePostSubmitted(id) {
            this.publisherFollowLoading = true
            // setuserfollowAdd
            let res = await setuserfollowAdd({ tuf_be_follow_user_id: id });
            if (res.status == 200) {
                this.$message.success(res.msg);
                this.info.publisher_info.have_be_follow = !this.info.publisher_info.have_be_follow;
            }
            this.publisherFollowLoading = false
        },
        // 换一批
        changeRelated() {
            this.refreshLoading = true;
            related({
                id: this.tpId
            }).then(res => {
                this.info.relation_post_list = res.data.data
            }).finally(() => {
                this.refreshLoading = false;
            });
        }
    },
};
</script>

<style lang="scss" scoped>
.attachment-box {


    .attachment-list {
        margin-top: 26px;
        // padding-top: 26px;
        text-align: center;
        width: 180px;
    }

    img {
        width: 78px;
    }

    .title {
        font-size: 14px;
        color: #040a16;
        line-height: 22px;
        margin-top: 8px;
    }

    .size,
    .download {
        font-weight: 400;
        font-size: 14px;
        color: #858d9e;
        line-height: 22px;
    }

    .btn {
        font-size: 14px;
        min-width: 64px;
        height: 26px;
        padding: 0 12px;
        border-radius: 16px;
        line-height: 26px;
        margin-top: 16px;
    }
}

.discuss-content {
    padding: 0 80px 36px;
}

.discuss-box {
    max-width: 1400px;
    margin: 0 auto;
    border-radius: 4px;
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.05);
    background: rgb(255, 255, 255);
    padding: 28px 40px 156px;
}

.content-box {
    min-height: calc(100vh - 280px);
    background: #f9f9f9;
}

.sharewx-link {
    width: 120px;
    background-color: #fff;
    border-radius: 6px;
    padding: 12px;
    box-shadow: 6px 10px 20px rgba(0, 0, 0, 0.2);
    right: -180px;
    bottom: 0;
    opacity: 0;
    visibility: hidden;
    transition: all 0.36s;

    a {
        padding-left: 22px;
        position: relative;
        z-index: 10000;
    }

    a:hover {
        color: #b7251e;
    }
}

.share-box .shares-box:hover {
    .sharewx-link {
        right: -160px;
        bottom: 0;
        opacity: 1;
        visibility: visible;
    }
}

.bdsharebuttonbox {
    position: relative;

    .shares {
        position: absolute;
        left: 0;
        top: 0;
    }

    .bds_more {
        background-image: none;
    }

    a::after {
        width: 52px;
        height: 84px;
        content: "";
        display: inline-block;
        color: #040a16;
        font-size: 16px;
        text-align: left;
        position: absolute;
        left: 0;
        top: 0px;
    }
}

.info-box {
    max-width: 1400px;
    margin: 0 auto;
    padding-top: 14px;

    .share-box {
        margin-top: 120px;

        .list {
            text-align: center;
            margin: 0 20px;
            cursor: pointer;
            transition: all 0.3s;

            &:hover,
            &.active {
                .p1 {
                    color: #1890ff !important;
                }

                .round {
                    color: #1890ff;

                    .number,
                    .iconfont {
                        color: #1890ff;
                    }
                }
            }

            .round {
                width: 52px;
                height: 52px;
                border-radius: 50%;
                text-align: center;
                box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.15);
                background: rgb(255, 255, 255);

                .iconfont {
                    font-size: 16px;
                    color: #878787;
                }

                .number {
                    font-size: 12px;
                    line-height: 12px;
                    margin-top: 5px;
                    color: #878787;
                }
            }

            .p1 {
                color: rgb(135, 135, 135);
                font-size: 14px;
                line-height: 20px;
                margin-top: 12px;
            }
        }
    }

    .left-box {
        width: calc(100% - 352px);
        border-radius: 4px;
        box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.05);
        background: rgb(255, 255, 255);
        padding: 28px 40px 156px;

        .text-content {
            margin-top: 21px;
            color: #333333;
            line-height: 1.75;
            padding-bottom: 26px;
            border-bottom: 1px dashed #d8d8d8;

            ::v-deep() {
                table{
                    max-width: 100%;
                }
                // td {
                //     border: 1px solid;
                // }

                a {
                    color: #0000ee;
                    text-decoration: underline;
                }

                i {
                    font-style: italic;
                }

                strong {
                    font-weight: bold;
                }

                ol,
                ul {
                    margin-left: 24px;
                }

                img,
                video {
                    max-width: 100%;
                    height: auto;
                }
            }

        }

        .abstract-box {
            color: #595959;
            font-size: 14px;
            font-weight: 300;
            line-height: 24px;
            padding-left: 10px;
            position: relative;
            margin-top: 21px;

            &::after {
                content: "";
                display: block;
                width: 2px;
                height: 100%;
                border-radius: 0px 1px 1px 0px;
                position: absolute;
                left: 0;
                top: 0;
                background: linear-gradient(197.15deg,
                        rgb(174, 0, 0) 0.013%,
                        rgba(255, 255, 255, 0) 161.578%);
            }

            span {
                font-family: "MicrosoftYaHeiSemibold";
            }
        }

        .author-box {
            font-size: 14px;
            line-height: 20px;
            margin-top: 16px;

            .author {
                color: rgb(25, 25, 25);
            }

            .browse {
                font-size: 14px;
                line-height: 14px;
                margin-left: 21px;

                .iconfont {
                    margin-right: 3px;
                }
            }

            .date {
                color: rgb(119, 119, 119);
                margin-left: 21px;
            }
        }

        .title {
            .t1 {
                color: rgb(25, 25, 25);
                font-family: "MicrosoftYaHeiSemibold";
                font-size: 26px;
                line-height: 30px;
            }

            .s1 {
                color: rgb(25, 25, 25);
                font-size: 12px;
                line-height: 30px;
                cursor: pointer;

                &:hover {
                    color: #b7251e;
                }
            }
        }
    }

    .right-box {
        width: 340px;
        margin-left: 12px;
        height: fit-content;
        position: sticky;
        top: 60px;

        /* 距离顶部的距离 */
        .article-boxs {
            margin-top: 16px;

            .list {
                cursor: pointer;
            }

            .list:hover {
                .tit1 {
                    color: #b7251e;
                }
            }

            .tit1 {
                color: rgb(25, 25, 25);
                font-size: 14px;
                font-weight: 400;
                line-height: 22px;
            }

            .type {
                font-size: 12px;
                line-height: 29px;
                color: #868d9f;

                .iconfont {
                    font-size: 13px;
                    margin-right: 6px;
                    color: #868d9f;
                }
            }
        }

        .article-box {
            .title {
                .btn {
                    font-size: 12px;
                    border: none;
                    padding: 0;
                    margin: 0;
                }

                .iconfont {
                    font-size: 12px;
                    margin-right: 4px;
                    color: #b7251e;
                }
            }
        }

        .btn-box {
            padding: 0 12px;
            margin-top: 36px;

            button {
                min-width: 122px;
                border-radius: 8px;
                height: 32px;
                padding: 0;
            }

            .btn1 {}

            .btn2 {}
        }

        .type-list {
            text-align: center;
            margin-top: 19px;

            p {
                font-size: 14px;
                color: #858d9e;
                line-height: 18px;
            }

            span {
                font-family: "MicrosoftYaHeiSemibold";
                font-size: 18px;
                color: #040a16;
                line-height: 24px;
                display: inline-block;
                margin-top: 3px;
            }
        }

        .author-content,
        .article-box {
            width: 100%;
            min-height: 155px;
            border-radius: 4px;
            box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.05);
            background: rgb(255, 255, 255);
            padding: 16px;

            .title {
                color: rgb(25, 25, 25);
                font-family: "MicrosoftYaHeiSemibold";
                font-size: 20px;
                line-height: 24px;
            }
        }

        .user-info {
            margin-top: 26px;

            .avatar {
                position: relative;

                &::after {
                    content: "";
                    display: block;
                    width: 56px;
                    height: 56px;
                    border-radius: 50%;
                    border: 1px solid #799eeb;
                    position: absolute;
                    top: -4px;
                    left: -4px;
                }

                &::before {
                    content: "";
                    display: block;
                    width: 64px;
                    height: 64px;
                    border-radius: 50%;
                    border: 1px solid #cadeff;
                    position: absolute;
                    top: -8px;
                    left: -8px;
                }
            }

            .name {
                color: rgb(25, 25, 25);
                font-size: 16px;
                line-height: 24px;
                margin-left: 24px;
            }
        }
    }
}

.container {
    padding: 60px 80px 0;

}
</style>